import {Injectable, Injector} from "@angular/core";
import {CleverreportStoreState} from "../cleverreport.store.module";
import {Store} from "@ngrx/store";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {Observable} from "rxjs/Observable";
import {RemarkEntity} from "./remark.entity";
import {RemarkActions} from "./remark.actions";

@Injectable()
export class RemarkService {

  private databaseProvider;

  constructor(private store: Store<CleverreportStoreState>, private injector: Injector) {
    setTimeout(() => {
      this.databaseProvider = injector.get(DataProvider);
    })
  }

  addAll(remarks: Array<RemarkEntity>, synced: boolean = true): void {
    if (!synced) {
      for (let remark of remarks) {
        if (!location.hasOwnProperty('_id')) {
          this.databaseProvider.createDocumentWithoutInit(remark)
            .then((remark: RemarkEntity) => {
              this.store.dispatch(RemarkActions.add(remark));
            })
        }
      }
    } else {
      this.store.dispatch(RemarkActions.addAll(remarks));
    }
  }

  add(remark: RemarkEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.createDocumentWithoutInit(remark)
        .then((remark: RemarkEntity) => {
          this.store.dispatch(RemarkActions.add(remark));
        })
    } else {
      this.store.dispatch(RemarkActions.add(remark));
    }
  }

  set(remark: RemarkEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.updateDocument(remark)
        .then((remark: RemarkEntity) => {
          this.store.dispatch(RemarkActions.add(remark));
        })
    } else {
      this.store.dispatch(RemarkActions.set(remark));
    }
  }

  remove(remark: RemarkEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.softDeleteDocument(remark)
        .then(() => {
          this.store.dispatch(RemarkActions.remove(remark._id));
        });
    } else {
      this.store.dispatch(RemarkActions.remove(remark._id));
    }
  }

  getById(id: string): Observable<RemarkEntity> {
    return this.store.select('remarks').map((remarks: Array<RemarkEntity>) => {
      return remarks.find((remark: RemarkEntity) => {
        return remark._id === id;
      });
    });
  }

  public getAll(): Observable<Array<RemarkEntity>> {
    return this.store.select('remarks')
      .map((bemerkungen: Array<any>) => {
      return bemerkungen
        .filter((remark: RemarkEntity) => {
          return !remark.hasOwnProperty('_deleted') && !remark.hasOwnProperty('deleted');
        })
        .sort(function(a, b) {
        if(!b.category){
          return -1;
        }
        else if(!a.category){
          return 1;
        }
        else if(a.category.toLowerCase() === b.category.toLowerCase()){
          return 0;
        }
        else {
          return a.category.toLowerCase() < b.category.toLowerCase() ? -1 : 1;
        }
      });
    });
  }

  public getCategories(): Observable<Array<string>> {
    return this.store.select('remarks')
      .map((remarks: Array<RemarkEntity>) => {
        let categories: Array<string> = [];
        for(let remark of remarks){
          if(categories.indexOf(remark.category) === -1){
            categories.push(remark.category);
          }
        }
        return categories.sort((category1, category2) => {
          if (category1.toLowerCase() < category2.toLowerCase()) {
            return -1;
          }
          if (category1.toLowerCase() > category2.toLowerCase()) {
            return 1;
          }
          // a muss gleich b sein
          return 0;
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/store/remark/remark.service.ts